<template>
  <div class="organization-main">
    <SideCard/>
    <TableCard />
  </div>
</template>
<script>
import SideCard from '../components/organize/SideCard.vue'
import TableCard from '../components/organize/TableCard.vue'

export default {
  components: {
    SideCard,
    TableCard
  }
}
</script>
<style scoped>
.organization-main {
  display: flex;
  flex-direction: row;
  width: 100%;
}
</style>
